import { FormBase } from 'core/components';

export default class ExportLabelsForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'carrierService',
					label: 'FULFILLMENTORDER.EXPORTLABELSMODAL.CARRIERSERVICE',
					rules: 'required',
				},
				
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/ExportLabelsForm.js